import React, { useEffect, useRef } from 'react';
import { Link } from 'gatsby';

import * as styles from './Footer.module.scss';

import HorizontalRule from '../HorizontalRule/HorizontalRule';

import logoSmallImg from '../../images/logo--small.svg';
import IconMapSearch from '../Icons/IconMapSearch';
import IconPhone from '../Icons/IconPhone';
import IconMail from '../Icons/IconMail';

const Footer = (): JSX.Element => {
    const currentYear = new Date().getFullYear();
    const scriptContainerRef = useRef<HTMLDivElement>(null);

    // Dynamically inject an external script and configuration
    useEffect(() => {
        const container = scriptContainerRef.current;
        if (!container || container.querySelector('script')) {
            return undefined;
        }

        // eslint-disable-next-line no-underscore-dangle
        window._checkatradeConfig = {
            companyId: '9717860',
            uniqueName: 'ConstructsBuildingLtd',
            theme: 'white',
        };

        const script = document.createElement('script');
        script.src = 'https://www.checkatrade.com/static/js/widget.js';
        script.async = true;
        container.appendChild(script);

        return () => {
            container.innerHTML = '';
        };
    }, []);

    return (
        <footer className={styles.Footer}>
            <div className="contain py-5 space-y-5">
                <div className="flex items-center justify-between">
                    <img src={logoSmallImg} alt="Small logo" width={32} height={29} />
                    <nav className="space-x-2">
                        <Link to="/" className={`${styles.FooterLink} text-smallcaps`}>Home</Link>
                        <Link to="/design" className={`${styles.FooterLink} text-smallcaps`}>Design</Link>
                        <Link to="/build" className={`${styles.FooterLink} text-smallcaps`}>Build</Link>
                        <Link to="/contact" className={`${styles.FooterLink} text-smallcaps`}>Contact</Link>
                    </nav>
                </div>
                <HorizontalRule color="bronze-700" />
                <div className={styles.FooterContact}>
                    <div className="flex basis-auto gap-1">
                        <IconMapSearch size="24px" />
                        <address className="text-smallcaps">
                            30 Stanwick Drive<br />
                            Wyman's Brook<br />
                            Cheltenham<br />
                            GL51 9LG
                        </address>
                    </div>
                    <div className="flex basis-auto gap-1">
                        <IconPhone size="24px" />
                        <div>
                            <a href="tel:07791636845" className={`${styles.FooterLink} text-smallcaps`}>07791 636 845</a>
                        </div>
                    </div>
                    <div className="flex basis-auto gap-1 items-center">
                        <IconMail size="24px" />
                        <a href="mailto:office@constructsbuilding.co.uk" className={`${styles.FooterLink} text-smallcaps`}>office@constructsbuilding.co.uk</a>
                    </div>
                </div>
                <HorizontalRule color="bronze-700" />
                <div className="contain containMedium">
                    {/* Use a target div for injecting the script */}
                    <div ref={scriptContainerRef} />
                </div>
                <div className="sm:text-center leading-tight">
                    <span className="text-smallcaps">&copy; {currentYear}, All rights reserved.</span><br />
                    <Link to="/privacy-policy" className={`${styles.FooterLink} text-smallcaps`}>Privacy policy</Link>
                </div>
                <HorizontalRule color="bronze-700" />
                <nav className="sm:text-center">
                    <Link to="/builders-cheltenham" className={`${styles.FooterLink} text-smallcaps`}>Builders Cheltenham</Link>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
